<template>
    <div>
        <template v-if="data === true">
            <div class="corporate-cards-main">
                <iframe :src="iFrameUrl" frameborder="0" width="100%" title="E Money Statements"></iframe>
            </div>
        </template>
        <template v-if="data === null"><preLoader></preLoader></template>
        <template v-if="data === false"><notAllowed></notAllowed></template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                data : null,
                greenline_card : null,
                iFrameUrl : null
            };
        },
        methods: {
            getIFrameUrl(){
                this.$Progress.start();
                axios.get('/api/getGreenlineCardIframeURL')
                .then(res => {
                    if(res.status == 200){
                    this.iFrameUrl = res.data;
                    this.data = true;
                    }else{
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load data');
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','system error');
                    console.log(err);
                });
            }
        },
        mounted() {
            var gThat = this;
            this.$Progress.start();
            this.can('greenline_card').then(result=>{
                this.greenline_card = result.greenline_card;
                // this.greenline_card = true;
            }).then(result=>{
                if(this.greenline_card === true){
                    this.getIFrameUrl();
                }else{
                    this.data = false;
                }
            })
        }
    }
</script>
